export const allFolders = "qdb";
export default {allFolders};